import { render } from "./ComboBoxLazy.vue?vue&type=template&id=be38e7a2"
import script from "./ComboBoxLazy.vue?vue&type=script&lang=js"
export * from "./ComboBoxLazy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__